import Vue from "vue";
import Router from "vue-router";
import Homeone from "@/demo_page/home_one";
import Navbar from "@/components/navbar";
import NavbarNested from "@/components/navbar_nested";
import About from "@/components/about";
import Feature from "@/components/feature";
import Screenshots from "@/components/screenshots";
import Testimonial from "@/components/testimonial";
import ContactUs from "@/components/contact_us";
import Subscribe from "@/components/subscribe";
import Tile from "@/components/tile";
import Footer from "@/components/footer";
import PageNotFound from "@/components/pagenotfound";
import js from "@/components/js";
import Signin from "@/pages/sign_in";
import Signup from "@/pages/sign_up";
import ForgetPassword from "@/pages/forget_password";
import Review from "@/pages/review";
import Thankyou from "@/pages/thank_you";
import Faq from "@/pages/faq";
import download from "@/pages/download";
import comingsoon from "@/pages/coming_soon";
import Emailtemplate from "@/pages/email_template";
import color from "@/components/color";
import Team from "@/components/Team";
import AnimatedLogo from "@/components/animated-logo";
import LanguageSelector from "@/components/langaugeselector";

import Walkthrough from "@/pages/walkthrough";
import Car from "@/pages/walkthrough/car";
import Office from "@/pages/walkthrough/office";
import JailCell from "@/pages/walkthrough/jailcell";
import Garage from "@/pages/walkthrough/garage";
import SpanishCar from "@/pages/walkthrough/es/car";
import SpanishOffice from "@/pages/walkthrough/es/office";
import SpanishJailCell from "@/pages/walkthrough/es/jailcell";
import SpanishGarage from "@/pages/walkthrough/es/garage";
import GermanCar from "@/pages/walkthrough/de/car";
import GermanOffice from "@/pages/walkthrough/de/office";
import GermanJailCell from "@/pages/walkthrough/de/jailcell";
import GermanGarage from "@/pages/walkthrough/de/garage";
import FrenchCar from "@/pages/walkthrough/fr/car";
import FrenchOffice from "@/pages/walkthrough/fr/office";
import FrenchJailCell from "@/pages/walkthrough/fr/jailcell";
import FrenchGarage from "@/pages/walkthrough/fr/garage";
import ItalianCar from "@/pages/walkthrough/it/car";
import ItalianOffice from "@/pages/walkthrough/it/office";
import ItalianJailCell from "@/pages/walkthrough/it/jailcell";
import ItalianGarage from "@/pages/walkthrough/it/garage";

import Terms from "@/pages/terms";
import PuzzleGiveaway from "@/pages/puzzlegiveaway";
import PuzzleOfTheDayPrivacy from "@/pages/privacy/puzzleoftheday";
import PuzzleOfTheDayPrivacyGoogle from "@/pages/privacy/puzzleofthedaygoogle";
import AngelInvestorPrivacy from "@/pages/privacy/angelinvestor";
import ChristmasEscapePrivacy from "@/pages/privacy/christmasescape";
import SleepingSoundsPrivacy from "@/pages/privacy/sleepingsounds";
import DailyAffirmationPrivacy from "@/pages/privacy/dailyaffirmation";
import DailyMeditationPrivacy from "@/pages/privacy/dailymeditation";
import MeditationOfTheDayPrivacy from "@/pages/privacy/meditationoftheday";
import PositiveAffirmationPrivacy from "@/pages/privacy/positiveaffirmation";
import MindfulMeditationPrivacy from "@/pages/privacy/mindfulmeditation";
import QuoteOfTheDayPrivacy from "@/pages/privacy/quoteoftheday";
import WetFartPrivacy from "@/pages/privacy/wetfart";
import JuicyFartPrivacy from "@/pages/privacy/juicyfart";
import EscapeTheAirplanePrivacy from "@/pages/privacy/escapetheairplane";
import EscapeTheRoomPrivacy from "@/pages/privacy/escapetheroom";
import EscapeTheRoomPrivacyGoogle from "@/pages/privacy/escapetheroomgoogle";
import FiveMinuteWorkoutPrivacy from "@/pages/privacy/fiveminuteworkout";
import WordPlayPrivacy from "@/pages/privacy/wordplay";
import WordWizPrivacy from "@/pages/privacy/wordwiz";
import GameOfWordsPrivacy from "@/pages/privacy/gameofwords";
import GoodNightPrivacy from "@/pages/privacy/goodnight";

Vue.use(Router);
Vue.component("Navbar", Navbar);
Vue.component("LanguageSelector", LanguageSelector);
Vue.component("NavbarNested", NavbarNested);
Vue.component("About", About);
Vue.component("Feature", Feature);
Vue.component("Screenshots", Screenshots);
Vue.component("Testimonial", Testimonial);
Vue.component("Contact_us", ContactUs);
Vue.component("Subscribe", Subscribe);
Vue.component("Footer", Footer);
Vue.component("Signin", Signin);
Vue.component("Signup", Signup);
Vue.component("ForgetPassword", ForgetPassword);
Vue.component("Thankyou", Thankyou);
Vue.component("Review", Review);
Vue.component("Faq", Faq);
Vue.component("download", download);
Vue.component("comingsoon", comingsoon);
Vue.component("Emailtemplate", Emailtemplate);
Vue.component("js", js);
Vue.component("Tile", Tile);
Vue.component("Team", Team);

Vue.component("color", color);
Vue.component("AnimatedLogo", AnimatedLogo);

Vue.component("Terms", Terms);
Vue.component("AngelInvestorPrivacy", AngelInvestorPrivacy);
Vue.component("PuzzleGiveaway", PuzzleGiveaway);
Vue.component("PuzzleOfTheDayPrivacy", PuzzleOfTheDayPrivacy);
Vue.component("PuzzleOfTheDayPrivacyGoogle", PuzzleOfTheDayPrivacyGoogle);
Vue.component("ChristmasEscapePrivacy", ChristmasEscapePrivacy);
Vue.component("EscapeTheAirplanePrivacy", EscapeTheAirplanePrivacy);
Vue.component("EscapeTheRoomPrivacy", EscapeTheRoomPrivacy);
Vue.component("EscapeTheRoomPrivacyGoogle", EscapeTheRoomPrivacyGoogle);
Vue.component("FiveMinuteWorkoutPrivacy", FiveMinuteWorkoutPrivacy);
Vue.component("WordPlayPrivacy", WordPlayPrivacy);
Vue.component("WordWizPrivacy", WordWizPrivacy);
Vue.component("GameOfWordsPrivacy", GameOfWordsPrivacy);
Vue.component("GoodNightPrivacy", GoodNightPrivacy);

Vue.component("SleepingSoundsPrivacy", SleepingSoundsPrivacy);
Vue.component("DailyAffirmationPrivacy", DailyAffirmationPrivacy);
Vue.component("DailyMeditationPrivacy", DailyMeditationPrivacy);
Vue.component("MeditationOfTheDayPrivacy", MeditationOfTheDayPrivacy);
Vue.component("PositiveAffirmationPrivacy", PositiveAffirmationPrivacy);
Vue.component("MindfulMeditationPrivacy", MindfulMeditationPrivacy);
Vue.component("QuoteOfTheDayPrivacy", QuoteOfTheDayPrivacy);
Vue.component("WetFartPrivacy", WetFartPrivacy);
Vue.component("JuicyFartPrivacy", JuicyFartPrivacy);

Vue.component("Garage", Garage);
Vue.component("JailCell", JailCell);
Vue.component("Office", Office);
Vue.component("Car", Car);

Vue.component("SpanishGarage", SpanishGarage);
Vue.component("SpanishJailCell", SpanishJailCell);
Vue.component("SpanishOffice", SpanishOffice);
Vue.component("SpanishCar", SpanishCar);

Vue.component("GermanGarage", GermanGarage);
Vue.component("GermanJailCell", GermanJailCell);
Vue.component("GermanOffice", GermanOffice);
Vue.component("GermanCar", GermanCar);

Vue.component("FrenchCar", FrenchCar);
Vue.component("FrenchOffice", FrenchOffice);
Vue.component("FrenchJailCell", FrenchJailCell);
Vue.component("FrenchGarage", FrenchGarage);

Vue.component("ItalianCar", ItalianCar);
Vue.component("ItalianOffice", ItalianOffice);
Vue.component("ItalianJailCell", ItalianJailCell);
Vue.component("ItalianGarage", ItalianGarage);

Vue.component("Walkthrough", Walkthrough);

export default new Router({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            name: "home",
            components: {
                default: Homeone,
                navbar: Navbar
            }
        },
        {
            path: "/walkthrough/office",
            name: "office",
            alias: "/office.html",
            components: {
                default: Office,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/car",
            name: "car",
            alias: "/car.html",
            components: {
                default: Car,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/jailcell",
            name: "jailcell",
            alias: "/jailcell.html",
            components: {
                default: JailCell,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/garage",
            name: "garage",
            alias: "/garage.html",
            components: {
                default: Garage,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/de/office",
            name: "germanoffice",
            alias: "/de/office.html",
            components: {
                default: GermanOffice,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/de/car",
            name: "germancar",
            alias: "/de/car.html",
            components: {
                default: GermanCar,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/de/jailcell",
            name: "germanjailcell",
            alias: "/de/jailcell.html",
            components: {
                default: GermanJailCell,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/de/garage",
            name: "germangarage",
            alias: "/de/garage.html",
            components: {
                default: GermanGarage,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/es/office",
            name: "spanishoffice",
            alias: "/es/office.html",
            components: {
                default: SpanishOffice,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/es/car",
            name: "spanishcar",
            alias: "/es/car.html",
            components: {
                default: SpanishCar,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/es/jailcell",
            name: "spanishjailcell",
            alias: "/es/jailcell.html",
            components: {
                default: SpanishJailCell,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/es/garage",
            name: "spanishgarage",
            alias: "/es/garage.html",
            components: {
                default: SpanishGarage,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/fr/office",
            name: "frenchoffice",
            alias: "/fr/office.html",
            components: {
                default: FrenchOffice,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/fr/car",
            name: "frenchcar",
            alias: "/fr/car.html",
            components: {
                default: FrenchCar,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/fr/jailcell",
            name: "frenchjailcell",
            alias: "/fr/jailcell.html",
            components: {
                default: FrenchJailCell,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/fr/garage",
            name: "frenchgarage",
            alias: "/fr/garage.html",
            components: {
                default: FrenchGarage,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/it/office",
            name: "italianoffice",
            alias: "/it/office.html",
            components: {
                default: ItalianOffice,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/it/car",
            name: "italiancar",
            alias: "/it/car.html",
            components: {
                default: ItalianCar,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/it/jailcell",
            name: "italianjailcell",
            alias: "/it/jailcell.html",
            components: {
                default: ItalianJailCell,
                navbar: NavbarNested
            }
        },
        {
            path: "/walkthrough/it/garage",
            name: "italiangarage",
            alias: "/it/garage.html",
            components: {
                default: ItalianGarage,
                navbar: NavbarNested
            }
        },
        {
            path: "/terms",
            name: "terms",
            alias: "/terms/index.html",
            components: {
                default: Terms,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/pod",
            name: "puzzleofthedayprivacy",
            alias: "/privacy/pod.html",
            components: {
                default: PuzzleOfTheDayPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/pod-google",
            name: "puzzleofthedayprivacygoogle",
            alias: "/privacy/pod-google.html",
            components: {
                default: PuzzleOfTheDayPrivacyGoogle,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/angelinvestor",
            name: "angelinvestorprivacy",
            alias: "/privacy/angelinvestor.html",
            components: {
                default: AngelInvestorPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/christmasescape",
            name: "christmasescapeprivacy",
            alias: "/privacy/christmasescape.html",
            components: {
                default: ChristmasEscapePrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/sleepingsounds",
            name: "sleepingsoundsprivacy",
            alias: "/privacy/sleepingsounds.html",
            components: {
                default: SleepingSoundsPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/dailymeditation",
            name: "dailymeditationprivacy",
            alias: "/privacy/dailymeditation.html",
            components: {
                default: DailyMeditationPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/meditationoftheday",
            name: "meditationoftheday",
            alias: "/privacy/meditationoftheday.html",
            components: {
                default: MeditationOfTheDayPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/dailyaffirmation",
            name: "dailyaffirmationprivacy",
            alias: "/privacy/dailyaffirmation.html",
            components: {
                default: DailyAffirmationPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/positiveaffirmation",
            name: "positiveaffirmationprivacy",
            alias: "/privacy/positiveaffirmation.html",
            components: {
                default: PositiveAffirmationPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/mindfulmeditation",
            name: "mindfulmeditationprivacy",
            alias: "/privacy/mindfulmeditation.html",
            components: {
                default: MindfulMeditationPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/quoteoftheday",
            name: "quoteofthedayprivacy",
            alias: "/privacy/quoteoftheday.html",
            components: {
                default: QuoteOfTheDayPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/celebrityquote",
            name: "celebrityquote",
            alias: "/privacy/celebrityquote.html",
            components: {
                default: QuoteOfTheDayPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/wetfart",
            name: "wetfartprivacy",
            alias: "/privacy/wetfart.html",
            components: {
                default: WetFartPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/juicyfart",
            name: "juicyfartprivacy",
            alias: "/privacy/juicyfart.html",
            components: {
                default: JuicyFartPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/escapetheairplane",
            name: "escapetheairplaneprivacy",
            alias: "/privacy/escapetheairplane.html",
            components: {
                default: EscapeTheAirplanePrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/escapetheroom",
            name: "escapetheroomprivacy",
            alias: "/privacy/escapetheroom.html",
            components: {
                default: EscapeTheRoomPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/escapetheroom-google",
            name: "escapetheroomprivacygoogle",
            alias: "/privacy/escapetheroom-google.html",
            components: {
                default: EscapeTheRoomPrivacyGoogle,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/fiveminuteworkout",
            name: "fiveminuteworkoutprivacy",
            alias: "/privacy/fiveminuteworkout.html",
            components: {
                default: FiveMinuteWorkoutPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/wordplay",
            name: "wordplayprivacy",
            alias: "/privacy/wordplay.html",
            components: {
                default: WordPlayPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/wordwiz",
            name: "wordwizprivacy",
            alias: "/privacy/wordwiz.html",
            components: {
                default: WordWizPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/goodnight",
            name: "goodnightprivacy",
            alias: "/privacy/goodnight.html",
            components: {
                default: GoodNightPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/privacy/gameofwords",
            name: "gameofwordsprivacy",
            alias: "/privacy/gameofwords.html",
            components: {
                default: GameOfWordsPrivacy,
                navbar: NavbarNested
            }
        },
        {
            path: "/puzzlegiveaway",
            name: "puzzlegiveaway",
            alias: "/puzzlegiveaway.html",
            components: {
                default: PuzzleGiveaway,
                navbar: NavbarNested
            }
        },
        /* {
          path: '/tovo',
          name: 'Main_page',
          component: Main
        }, */
        {
            path: "/",
            name: "Home_one",
            components: {
                default: Homeone,
                navbar: Navbar
            }
        } /*
    {
      path: '/tovo/home-two',
      name: 'Home_two',
      components: {
        default: Hometwo,
        navbar: Navbar,
      }
    },
    {
      path: '/tovo/home-three',
      name: 'Home_three',
      components: {
        default: Homethree,
        navbar: Navbar,
      }
    }, */,
        {
            path: "/404",
            name: "pagenotfound",
            component: PageNotFound
        },
        /* {
      path: '/tovo/blog-list',
      name: 'blog_list',
      components: {
        default: Bloglist,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-details',
      name: 'Blog_details',
      components: {
        default: BlogDetails,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-leftside',
      name: 'Blog_leftside',
      components: {
        default: BlogLeftSide,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-rightside',
      name: 'Blog_rightside',
      components: {
        default: BlogRightSide,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-left-sidebar',
      name: 'BlogLeftSidebar',
      components: {
        default: BlogLeftSidebar,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-right-sidebar',
      name: 'BlogrightSidebar',
      components: {
        default: BlogRightSidebar,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/sign-in',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/tovo/sign-up',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/tovo/forget-Password',
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/tovo/thank-you',
      name: 'Thankyou',
      component: Thankyou
    },
    {
      path: '/tovo/review',
      name: 'Review',
      components: {
        default: Review,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/faq',
      name: 'Faq',
      components: {
        default: Faq,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/download',
      name: 'download',
      component: download
    },
    {
      path: '/tovo/coming-soon',
      name: 'coming_soon',
      component: comingsoon
    },
    {
      path: '/tovo/email-template',
      name: 'Emailtemplate',
      component: Emailtemplate
    }*/ {
            path: "*",
            redirect: "/tovo/404"
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js